export default __webpack_public_path__ + "static/media/CHash0.40432e03.mp3";